var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-center" },
    [
      _vm.userData.id === 0
        ? [
            _c(
              "a",
              {
                staticClass: "text-muted add-to-wish-list",
                on: {
                  click: function ($event) {
                    return _vm.showLogin()
                  },
                },
              },
              [
                _vm.loading
                  ? [
                      _c("i", {
                        staticClass: "fa fa-spin fa-circle-o-notch",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  : [
                      _c("i", {
                        staticClass: "fa fa-heart-o",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ],
                _vm._v(" "),
                _vm.showWording
                  ? [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Snaply5::Template.singleItemWishListBtn"
                          )
                        )
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : [
            _c(
              "a",
              {
                staticClass: "text-muted add-to-wish-list",
                on: {
                  "~mouseover": function ($event) {
                    return _vm.$store.dispatch("loadComponent", "csmodal")
                  },
                  click: function ($event) {
                    return _vm.addItem()
                  },
                },
              },
              [
                _vm.loading
                  ? [
                      _c("i", {
                        staticClass: "fa fa-spin fa-circle-o-notch",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  : [
                      _c("i", {
                        staticClass: "fa fa-heart-o",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ],
                _vm._v(" "),
                _vm.showWording
                  ? [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "Snaply5::Template.singleItemWishListBtn"
                          )
                        )
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }